import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-upload\"><path d=\"M8.706 5.706h2.173v10.09c0 .131.106.239.236.239h1.764c.13 0 .236-.108.236-.239V5.706h2.18c.196 0 .305-.23.184-.385l-3.294-4.23A.236.236 0 0012 1a.233.233 0 00-.185.092L8.52 5.318c-.121.158-.012.388.185.388zM22.765 14.9H21a.238.238 0 00-.235.239v4.593H3.235V15.14A.238.238 0 003 14.9H1.235A.238.238 0 001 15.14v5.905c0 .528.42.955.941.955H22.06c.52 0 .941-.427.941-.954V15.14a.238.238 0 00-.235-.239z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol